import { useLocation, useNavigate } from "react-router-dom";
import { NAVBAR_ITEMS_KEYS, NAVBAR_ITEMS_VALUES } from "@Constants/navbar";
import { NavigationRoutes } from "../../navigation/NavigationRoutes";

export const useAuthLayoutContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const route = location.pathname.split("/");

  // Map route paths to navbar keys
  const getSelectedKey = (pathname: string) => {
    if (pathname === "/dashboard") return NAVBAR_ITEMS_KEYS.DASHBOARD;
    if (pathname.startsWith("/user-management"))
      return NAVBAR_ITEMS_KEYS.USER_MANAGEMENT;
    if (pathname.startsWith("/subscription-management"))
      return NAVBAR_ITEMS_KEYS.SUBSCRIPTION_MANAGEMENT;
    if (pathname.startsWith("/profile-management"))
      return NAVBAR_ITEMS_KEYS.PROFILE;
    return NAVBAR_ITEMS_KEYS.DASHBOARD; // default
  };

  const selectedKey = getSelectedKey(location.pathname);
  let moduleTitle = NAVBAR_ITEMS_VALUES[selectedKey] ?? "Dashboard";

  const pathname = location.pathname;
  if (
    pathname.startsWith(`${NavigationRoutes.DASHBOARD_ROUTES.USER_DETAILS}`)
  ) {
    moduleTitle = "User Details";
  }
   else if (
    pathname.startsWith(`${NavigationRoutes.DASHBOARD_ROUTES.PROFILE_DETAILS}`)
  ) {
    moduleTitle = "Profile Details";
  }
  return { location, route, selectedKey, moduleTitle, navigate };
};
